import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import CircularProgress from '@material-ui/core/CircularProgress'
import Checkbox from '@material-ui/core/Checkbox'
import Typography from '@material-ui/core/Typography'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Grid from '@material-ui/core/Grid'

import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'

const LOCAL_STORAGE_CONFIRM_SAVE_KEY = 'atlas_hide_confirm_save_dialog'

export default function ConfirmSaveDialog (props) {
  const {
    open,
    onClose,
    onSave,
    isSaving,
    totalChanges
  } = props

  const [showDialog, setShowDialog] = React.useState(false)
  const [dontShowAgain, setDontShowAgain] = React.useState(false)

  React.useEffect(() => {
    const hideConfirmSaveDialog = localStorage.getItem(LOCAL_STORAGE_CONFIRM_SAVE_KEY)

    if (hideConfirmSaveDialog !== null) {
      setDontShowAgain(true)
    } else {
      setDontShowAgain(false)
    }
  }, [])

  React.useEffect(() => {
    // if we are trying to open the dialog
    if (open) {
      // if we have ticked to not display the dialog again
      if (dontShowAgain) {
        onSave() // just trigger the save event

        return // and dont show the dialog
      }
    }

    setShowDialog(open)
  }, [open])

  const handleChange = (event) => {
    setDontShowAgain(event.target.checked)

    if (event.target.checked) {
      localStorage.setItem(LOCAL_STORAGE_CONFIRM_SAVE_KEY, event.target.checked)
    } else {
      localStorage.removeItem(LOCAL_STORAGE_CONFIRM_SAVE_KEY)
    }
  }

  const handleClose = (event, reason) => {
    // don't close by clicking background
    if (reason === 'backdropClick') {
      return
    }

    onClose(event, reason)
  }

  return (
    <Dialog maxWidth="xs" fullWidth={true} open={showDialog} onClose={handleClose}>
      <DialogTitle>Are you sure you wish to Save?</DialogTitle>
      <DialogContent dividers>
        <Grid container>
          <Grid item xs={12}>
            <Typography>By selecting Ok to Save changes, you will be pushing {totalChanges} updates live immediately.</Typography>
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox checked={dontShowAgain} onChange={handleChange} style={{ color: '#0e70fb' }}/>
              }
              label={<Typography style={{ color: '#6d6d6d' }}>Don&apos;t show this again</Typography>}
              style={{ color: '00008a', marginTop: '12px' }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button autoFocus variant="contained" onClick={onSave} color="primary">
          {
            isSaving === true
              ? <><CircularProgress color="inherit" size={20} />&nbsp;&nbsp;</>
              : <><CheckCircleIcon />&nbsp;</>
          }
          Ok
        </Button>
        <Button variant="contained" onClick={onClose} color="secondary">
          <CancelIcon />&nbsp;Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ConfirmSaveDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
  totalChanges: PropTypes.number.isRequired
}
